import { LogLevel } from "@azure/msal-browser";

export const config_sso = {
  auth: {
    clientId: "a083e4c8-83a7-457d-9ba7-42d374b39426",
    //clientId: "6e75edfe-0bdc-4b7b-9ef1-014a28d6639c",
    //clientId:"be9e34d9-1000-47e0-931c-64084895679c",
    authority: "https://login.microsoftonline.com/common",
    knownAuthorities: [],
    //    redirectUri: document.location.hostname==='localhost'?"http://localhost:3001/maille/":"/maille/",
    //    postLogoutRedirectUri: document.location.hostname==='localhost'?"http://localhost:3001/maille/":"/maille/",
    //redirectUri: "/maille/",
    //postLogoutRedirectUri: "/maille/",
    //navigateToLoginRequestUrl: true,
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: window.location.href,
    redirectUri: window.location.href,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            //console.info(message);
            return;
          case LogLevel.Verbose:
            //console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
        }
      },
    },
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
  //domainHint: "6e75edfe-0bdc-4b7b-9ef1-014a28d6639c"
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me"
};